import React, { useCallback, useEffect } from 'react'
import CmdKGroup from '../CmdKGroup'
import CommandItem from '../CmdKItem'
import { AutoAwesomeRounded } from '@mui/icons-material'
import { useLocation } from '@cedarjs/router'
import { useOrgName } from 'src/hooks/useOrgName'
import { useRouteName } from '@cedarjs/router'
import { gql, useMutation } from '@apollo/client'
import useModal from 'src/hooks/useModal'
import useUserId from 'src/hooks/useUserId'

interface AIModuleProps {
  search: string
  onClose: () => void
}

const KICKOFF_MUTATION = gql`
  mutation CMDKCrewKickoff($input: CrewKickoffInput!) {
    crewKickoff(input: $input)
  }
`

const AIModule: React.FC<AIModuleProps> = ({ search, onClose }) => {
  const location = useLocation()
  const routeName = useRouteName()
  const orgName = useOrgName()
  const { id: userId } = useUserId()
  const term = `Can you tell me about "${search}"?`
  const { handleOpen, handleClose } = useModal('aiAnswerModal')

  const [kickoff] = useMutation(KICKOFF_MUTATION)

  useEffect(() => {
    // close the ai answer modal when the user re-opens cmdk
    handleClose()
  }, [handleClose])

  const handleAIChatClick = useCallback(async () => {
    onClose()
    // Call kickoff mutation
    const { data } = await kickoff({
      variables: {
        input: {
          crewName: 'question_and_answer',
          inputs: {
            additionalContext: `location: ${location.pathname} route: ${routeName} "User table primary key for this user": ${userId}`,
            orgSlug: orgName,
            prompt: search,
          },
        },
      },
    })
    const jobId = data?.crewKickoff
    if (!jobId) {
      return
    }
    handleOpen({ prompt: search, jobId })
  }, [
    onClose,
    kickoff,
    location.pathname,
    routeName,
    orgName,
    search,
    handleOpen,
    userId,
  ])

  // Hide AI group entirely if there is no search term
  if (!search?.trim()) {
    return null
  }

  return (
    <CmdKGroup heading="AI">
      {search && (
        <CommandItem
          startIcon={<AutoAwesomeRounded />}
          subtext="AI-powered features"
          onSelect={handleAIChatClick}
        >
          {term}
        </CommandItem>
      )}
      {/* <CommandItem
        disabled
        startIcon={<AutoAwesomeRounded />}
        subtext="AI-powered features"
        onSelect={handleAIChatClick}
        keywords={['always show']}
      >
        What is this page for?
      </CommandItem> */}
    </CmdKGroup>
  )
}

export default AIModule
